import { render, staticRenderFns } from "./ConsentForm_Form.vue?vue&type=template&id=f9a542e0&scoped=true&"
import script from "./ConsentForm_Form.vue?vue&type=script&lang=js&"
export * from "./ConsentForm_Form.vue?vue&type=script&lang=js&"
import style0 from "./ConsentForm_Form.vue?vue&type=style&index=0&id=f9a542e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9a542e0",
  null
  
)

export default component.exports